import { createFileRoute } from '@tanstack/react-router'
import { Questionario } from '@/features/portal/questionario'
import { PortalShell } from '@/features/portal/shell'

/**
 * Um questionário enviado a esta pessoa. O link pode chegar antes do login, e a
 * porta do `PortalShell` volta para cá depois de entrar. A palavra na URL e o
 * que aparece até lá não dizem de que atendimento se trata.
 */
export const Route = createFileRoute('/_portal/portal_/questionario/$id')({
  component: function QuestionarioDoPortal() {
    const { id } = Route.useParams()
    return (
      <PortalShell title="Questionário">
        <Questionario id={id} />
      </PortalShell>
    )
  },
})
